import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FullPageMaskService } from 'common';
import { lastValueFrom, Subject } from 'rxjs';
import { RtpOpaAssignment } from '../../interfaces/rtp-opa-assignment.interface';
import { AccountApiService } from '../../services/account-api.service';
import { rtpAssociatedOPAsSortingDataAccessor } from './rtp-associated-opas-sorting-data-accessor';

@Component({
  selector: 'si-rtp-associated-opas',
  templateUrl: './rtp-associated-opas.component.html',
  styleUrls: ['./rtp-associated-opas.component.scss'],
  standalone: true,
  imports: [MatTableModule, CommonModule, MatSortModule]
})
export class RtpAssociatedOpasComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  private readonly maskService = inject(FullPageMaskService);
  private readonly accountApiService = inject(AccountApiService);

  private _destroy$ = new Subject<void>();

  columns = ['accountCode', 'organisationName'];
  dataSource = new MatTableDataSource<RtpOpaAssignment>();

  async ngOnInit() {
    this.maskService.showLoading();

    this.sort.sort({ id: 'accountCodeAsc', start: 'asc', disableClear: false });
    this.dataSource.sort = this.sort;

    this.dataSource.sortingDataAccessor = rtpAssociatedOPAsSortingDataAccessor;
    
    try {
      this.dataSource.data = await lastValueFrom(this.accountApiService.getRtpOpaAssignmentList$());
    } finally {
      this.maskService.hideLoading();
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
  }
}
